import {
  SparklesIcon,
  BookOpenIcon,
  MusicalNoteIcon,
  HeartIcon,
  UserGroupIcon,
  PaintBrushIcon,
  FilmIcon,
  CakeIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/24/outline';

const enrichmentFeatures = [
  { icon: FilmIcon, label: 'Fitness Videos' },
  { icon: SparklesIcon, label: 'Brain Games' },
  { icon: CakeIcon, label: 'Recipes & Food Delivery' },
  { icon: BookOpenIcon, label: 'Books & Reading' },
  { icon: PaintBrushIcon, label: 'Art Museums & Galleries' },
  { icon: MusicalNoteIcon, label: 'Hobbies & My Garden' },
  { icon: HeartIcon, label: 'Pet Care' },
  { icon: CurrencyDollarIcon, label: 'Financial Planning' },
  { icon: UserGroupIcon, label: 'Your ThriveCircle' },
];

const GuidanceSection = () => {
  return (
    <div className="py-20 lg:py-28 bg-muted/20">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              Plus Everything That Makes{' '}
              <span className="text-primary">Life at Home Enjoyable</span>
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Thriving is not just about safety and wellness. SeniorThrive also supports the
              recipes you try, the hobbies you explore, the community you belong to, and the
              pets that keep you company.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10">
            {enrichmentFeatures.map((item, i) => (
              <div
                key={i}
                className="flex flex-col items-center gap-3 p-5 rounded-md bg-background shadow-raised hover:shadow-floating transition-all duration-300"
              >
                <item.icon className="w-8 h-8 text-primary" />
                <span className="text-foreground font-bold text-center leading-snug">
                  {item.label}
                </span>
              </div>
            ))}
          </div>

          <div className="text-center">
            <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
              Plus 7 AI companions for health, safety, cooking, medications, and more, friendly
              guidance whenever you need it.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuidanceSection;
